import { render, staticRenderFns } from "./ChoosePatientsForm.vue?vue&type=template&id=37279b4c"
import script from "./ChoosePatientsForm.vue?vue&type=script&lang=ts"
export * from "./ChoosePatientsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports